<template>
  <div class="sliding-switch-component">
    <span class="sliding-switch-component__slider" :style="sliderStyle" />
    <v-btn-toggle
      :value="value"
      mandatory
      borderless
      class="sliding-switch-component__toggle d-flex"
      @change="$emit('input', $event)"
    >
      <v-btn
        v-for="item in items"
        :key="item.value"
        :value="item.value"
        :disabled="item.disabled"
        :ripple="false"
        text
        class="sliding-switch-component__button"
      >
        {{ item.text }}
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
  export default {
    name: 'SlidingSwitch',
    props: {
      value: {
        type: [String, Number],
        default: null,
      },
      // [{ value, text, disabled? }]
      items: {
        type: Array,
        required: true,
      },
    },
    computed: {
      // ползунок шириной в одну позицию, translateX в процентах от своей ширины = сдвиг на позицию
      sliderStyle () {
        const index = Math.max(this.items.findIndex(item => item.value === this.value), 0)
        return {
          width: `calc((100% - 6px) / ${this.items.length})`,
          transform: `translateX(${index * 100}%)`,
        }
      },
    },
  }
</script>

<style lang="less" scoped>
// вид как у кнопок типа оплаты: серая плашка, выбранная позиция - оранжевая с белым текстом
.sliding-switch-component {
  position: relative;
  padding: 3px;
  background-color: @color-secondary;
  border-radius: 10px;
  box-shadow: 0 3px 6px #00000029;

  &__slider {
    position: absolute;
    top: 3px;
    bottom: 3px;
    left: 3px;
    background-color: @color-primary;
    border-radius: 8px;
    transition: transform 0.3s ease;
    pointer-events: none;
  }

  &__toggle {
    position: relative;
    width: 100%;
    background-color: transparent !important;
    border-radius: 8px;
  }

  &__button {
    flex: 1 1 0 !important;
    min-width: 0 !important;
    // Vuetify задаёт высоту кнопкам тогла селектором сильнее scoped-класса
    height: 48px !important;
    padding: 0 8px !important;
    font-size: 15px;
    line-height: 1.2;
    font-weight: 500;
    letter-spacing: 0;
    opacity: 1;
    color: #000000;
    background-color: transparent !important;
    transition: color 0.3s ease;

    &:before {
      display: none;
    }

    // позиций несколько, колонка узкая - текст переносим, иначе обрежется
    ::v-deep .v-btn__content {
      flex-shrink: 1;
      min-width: 0;
      white-space: normal;
      text-align: center;
    }

    &.v-item--active {
      color: #ffffff;
    }

    &.v-btn--disabled {
      color: @color-btn-grey !important;
    }
  }
}
</style>
